import type { EnumLabelKeys } from '@/lib/enum-labels/registry';
import { MetricId } from '@/types/generated/enums';

// Record<MetricId, …> is the guard: a metric added to the backend enum fails tsc until named here.
export const METRIC_LABEL_KEYS: EnumLabelKeys<MetricId> = {
  [MetricId.SPEND]: 'metric.spend',
  [MetricId.IMPRESSIONS]: 'metric.impressions',
  [MetricId.CLICKS]: 'metric.clicks',
  [MetricId.CONVERSIONS]: 'metric.conversions',
  [MetricId.CONVERSION_VALUE]: 'metric.conversion_value',
  [MetricId.REACH]: 'metric.reach',
  [MetricId.LANDING_PAGE_VIEWS]: 'metric.landing_page_views',
  [MetricId.LEADS]: 'metric.leads',
  [MetricId.PURCHASES]: 'metric.purchases',
  [MetricId.ROAS]: 'metric.roas',
  [MetricId.CPA]: 'metric.cpa',
  [MetricId.CPC]: 'metric.cpc',
  [MetricId.CTR]: 'metric.ctr',
  [MetricId.CPM]: 'metric.cpm',
  [MetricId.CPL]: 'metric.cpl',
  [MetricId.FREQUENCY]: 'metric.frequency',
  [MetricId.CONVERSION_RATE]: 'metric.conversion_rate',
  [MetricId.FORM_COMPLETION_RATE]: 'metric.form_completion_rate',
  [MetricId.POST_ENGAGEMENT]: 'metric.post_engagement',
  [MetricId.CONVERSATION_COUNT]: 'metric.conversation_count',
  [MetricId.POST_ENGAGEMENT_RATE]: 'metric.post_engagement_rate',
  [MetricId.COST_PER_ENGAGEMENT]: 'metric.cost_per_engagement',
  [MetricId.COST_PER_CONVERSATION]: 'metric.cost_per_conversation',
};

// Short forms for a table cell, where the long label would wrap the column.
export const COMPACT_LABEL_KEYS: Partial<EnumLabelKeys<MetricId>> = {
  [MetricId.IMPRESSIONS]: 'metric_compact.impressions',
  [MetricId.CONVERSIONS]: 'metric_compact.conversions',
  [MetricId.CONVERSION_VALUE]: 'metric_compact.conversion_value',
  [MetricId.LANDING_PAGE_VIEWS]: 'metric_compact.landing_page_views',
  [MetricId.CONVERSION_RATE]: 'metric_compact.conversion_rate',
  [MetricId.FORM_COMPLETION_RATE]: 'metric_compact.form_completion_rate',
  [MetricId.FREQUENCY]: 'metric_compact.frequency',
};
